import { inject, Injectable } from '@angular/core';
import { UserService } from '@features/sign-in/services/user.service';

@Injectable()
export class AuthGuard {
  private userService = inject(UserService);

  canActivate() {
    if (this.userService.isLoggedIn) {
      return true;
    }
    this.userService.logout('User logged out from auth guard');
    return false;
  }
}
